import script from "./SkipButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SkipButton.vue?vue&type=script&setup=true&lang=js"

import "./SkipButton.vue?vue&type=style&index=0&id=05d457a8&lang=scss"

const __exports__ = script;

export default __exports__